import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import WapperGetClient from "./wapperGetClient";
import { DualRing } from "react-loading-io";
import { useSelector } from "react-redux";
import persons from "../Resources/svg/boy.svg";
import BackButton from "./backButton";
import alert from "../Resources/img/icon-alert-yellow.png";
import { useDispatch } from "react-redux";
import { addRepLegal, updateContratant } from "./../Store/data/actions";
import { useHistory } from "react-router-dom";
import AlertMessage from "./alertMessage";
import ModalRetakeAsessory from "../Components/modalRetakeAsessory";
import { addRecommended } from "../Store/recommended/actions";
import { addIdProspecto } from "./../Store/prospect/actions";
import { getDataObtener, validateWatchList, validateWatchListV2 } from "../Utils/utils";
import { clientsType } from '../Utils/constants';
import ModalWhatchListV2 from "./modalWhatchListV2";
const HookFormContratantData = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const clientType = "DATOS DEL CONTRATANTE";
  const {
    handleSubmit,
    register,
    errors,
    getValues,
    setError,
    clearError,
    setValue,
    watch,
  } = useForm();

  const store = useSelector((state) => state.data);
  const asegurado = Object.values(store)[0];
  const contratante = Object.values(store)[1];
  const [loading, setLoading] = useState(false);
  const [dps, setDps] = useState(false);
  const [watchError, setWatchError] = useState(false);
  const channel = useSelector((state) => state.login.channel);
  const [isChecked, setIsChecked] = useState(false);
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [terceros, setTerceros] = useState();
  const [openModalWatchlist, setOpenModalWatchlist] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [blackList, setBlackList] = useState(false);
  const [yellowList, setYellowList] = useState(false);
  const [dataSubmit, setDataSubmit] = useState(null);
  const [dataWatchList, setDataWatchList] = useState();

  const [dataPerfil, setDataPerfil] = useState({
    name: "",
    date: "",
    perfil: "",
  });
  // redirect
  const passOk = () => history.push("/perfil-de-inversion");

  const getCheck = async (Assured, data, watchlist) => {
    try {
      setLoading(true);
      let response = await getDataObtener(Assured, data);
      setLoading(false);
      const contratantData = removeRepLegal(data);
      const repLegalData = extractRepLegal(data);

      dispatch(updateContratant({...contratantData, dataPlaft: watchlist ? watchlist : dataWatchList}));
      dispatch(addRepLegal(repLegalData))
      if (response.payload.data.resultadoPerfilamiento !== undefined) {
        dispatch(addIdProspecto(response.payload.idProspecto));
        dispatch(
          addRecommended({
            product: response.payload.data.resultadoPerfilamiento.producto,
            investmentProfile:
              response.payload.data.resultadoPerfilamiento.perfil,
          })
        );
        let perfil = { ...dataPerfil };
        perfil.name = data.names ? data.names : data.companyName;
        perfil.date = response.payload.fechaModificacion;
        perfil.perfil = response.payload.data.resultadoPerfilamiento.perfil;
        setDataPerfil(perfil);
        setOpenModalMessage(true);
      } else {
        setIsChecked(true);
      }
    } catch (ex) {
      setLoading(false);
      throw ex;
    }
  };

  useEffect(() => {
    if (asegurado === undefined) history.push("/productos");
    if (contratante) {
      if (contratante.nroDoc === asegurado.nroDoc) {
        setWatchError(true);
      } else if (contratante.nroDoc && isChecked) {
        setWatchError(false);
        passOk();
      } else {
        setWatchError(false);
      }
    }
  }, [store, isChecked]);

  const onSubmit = async (values) => {
    const data = {
      ...values,
      channel,
      clientType,
    };
    setDataSubmit(data);
    if (asegurado.nroDoc === values.nroDoc) {
      setWatchError(true);
    } else {
      setWatchError(false);

      try {
        setLoading(true);
        const { nroDoc, typeDoc, pep } = data;
        const watchlistv2 = typeDoc != '4' ? await validateWatchListV2(nroDoc, typeDoc, pep) : await validateWatchListV2(nroDoc, typeDoc);
        const {
          data: { lista, areas },
        } = watchlistv2;
        const watchlist = { lista, areas };
        setDataWatchList({lista, areas});
        if (lista) {
          setBlackList(lista === "black");
          setYellowList(lista === "yellow");
          setOpenModalWatchlist(lista !== "white");
          setLoading(false);
          if (lista === "black") return;
          if (lista === "white") defineContratantAction(data, watchlist);
        }

      
      } catch (error) {
        setErrorSubmit(true);
        window.scrollTo(0, 0);
        console.error(error);
        setLoading(false);
      }
    }
  };

  const extractRepLegal = (data) => {
    return Object.keys(data)
      .filter(key => key.endsWith("Replegal"))
      .reduce((obj, key) => {
        obj[key] = data[key];
        return obj;
      }, {});
  };
  
  const removeRepLegal = (data) => {
    return Object.keys(data)
      .filter(key => !key.endsWith("Replegal"))
      .reduce((obj, key) => {
        obj[key] = data[key];
        return obj;
      }, {});
  };

  const defineContratantAction = async (data, watchlist) => {
    if(data && watchlist){
      await getCheck(asegurado, data, watchlist);
    } else {
      await getCheck(asegurado, dataSubmit)
    }
  }

  const changeInvestmentProfile = () => {
    setOpenModalMessage(false);
    history.push("/perfil-de-inversion");
  };
  const continueInvestmentProfile = () => {
    setOpenModalMessage(false);
    history.push("/productos");
  };

  useEffect(() => {
    if(errorSubmit || watchError) window.scrollTo(0, 0);
    setTimeout(() => {
      setErrorSubmit(false);
      setWatchError(false);
    }, 4500);
  }, [errorSubmit, watchError]);

  return (
    <>
      <div className="adForm-container">
        <div className="adForm adForm--b product-ig">
          <div className="adForm__container-titles">
            <BackButton />
            <p className="adForm__container-titles__title">
              Datos del <span>contratante</span>
            </p>
            <p className="adForm__container-titles__sub-title">
              Conoce a la persona que se hará cargo del seguro
            </p>
          </div>

          {watchError && (
            <AlertMessage
              icono={alert}
              background="#FFEFD8"
              mensaje="Estás ingresando un DNI similar al asegurado. Valida que la información sea correcta.
          "
            />
          )}
          {errorSubmit && (
            <AlertMessage
              icono={alert}
              background="#FFEFD8"
              mensaje="Ha ocurrido un problema, intentar salir de la sesión y volver a entrar. Si persiste favor comunicarlo."
            />
          )}
          <br />
          <br />
          <form onSubmit={handleSubmit(onSubmit)} className="adForm__form contractorForm">
            <WapperGetClient
              register={register}
              getValues={getValues}
              clientType={clientsType.CONTRACTORS}
              errors={errors}
              setLoading={setLoading}
              setError={setError}
              clearError={clearError}
              setValue={setValue}
              setDps={setDps}
              hasDNI={true}
              setTerceros={setTerceros}
              watch={watch}
            />
            <div className="adForm__form__btnew-group align-btn">
              <button id="button_quote_vas" type="submit" className="btnew">
                CONTINUAR
              </button>
            </div>
          </form>
          {loading && (
            <div className="loading-field">
              <DualRing size={50} />
            </div>
          )}
        </div>
        <div className="person">
          <div className="person__img">
            <img src={persons} />
          </div>
        </div>
      </div>

      <ModalRetakeAsessory
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        title={dataPerfil.name + " YA TIENE UN PERFIL DE INVERSIÓN REGISTRADO"}
        subtitle="Perfil de inversión"
        investmentProfile={dataPerfil.perfil}
        registerDate={"Registrado el " + dataPerfil.date}
        firstButtonText="CAMBIAR"
        secondButtonText="CONTINUAR"
        firstButtonFunction={changeInvestmentProfile}
        secondButtonFunction={continueInvestmentProfile}
      />
      <ModalWhatchListV2 
        watchlist={openModalWatchlist} 
        setWatchlist={setOpenModalWatchlist}
        blackList={blackList}  
        yellowList={yellowList}
        formType="contratant"
        actionContratant={() => defineContratantAction(dataSubmit)}
      />
    </>
  );
};

export default HookFormContratantData;
